export default function WhyTrust() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">Why Authors Trust APEX</h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-8"></div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-10">
          <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-amber-500">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-shield-check-line text-4xl text-amber-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Proven Track Record</h3>
            <p className="text-gray-700 text-center leading-relaxed">
              We have worked—and still work—with respected and recognized book clubs that have established reputations in the literary community.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-amber-500">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-star-line text-4xl text-amber-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Selective Standards</h3>
            <p className="text-gray-700 text-center leading-relaxed">
              We don't promote every book. Our selective approach ensures that only standout titles receive our limited campaign slots, maintaining quality and credibility.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-amber-500">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-lightbulb-line text-4xl text-amber-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Expert Positioning</h3>
            <p className="text-gray-700 text-center leading-relaxed">
              With years of experience, we know exactly how to position your book so readers become genuinely interested and eager to discuss it.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-amber-500">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-team-line text-4xl text-amber-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Active Communities</h3>
            <p className="text-gray-700 text-center leading-relaxed">
              Our network includes over 300 highly engaged online and in-person book clubs with members who actively read, review, and discuss books.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-amber-500">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-chat-check-line text-4xl text-amber-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Clear Communication</h3>
            <p className="text-gray-700 text-center leading-relaxed">
              We communicate primarily through email for clarity and efficiency, ensuring you're always informed about your campaign's progress.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-amber-500">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-line-chart-line text-4xl text-amber-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Measurable Results</h3>
            <p className="text-gray-700 text-center leading-relaxed">
              Authors see increased visibility, genuine engagement from readers, and fast reviews from book club members who are excited to share their thoughts.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
